<style>
html,
body,
.page-container {
	width: 100%;
	height: 100%;
	overflow: hidden;
}
.full-width {
	width: 100%;
}
.full-height {
	height: 100%;
}
.display-flex {
	display: flex;
}
.display-flex-column {
	flex-direction: column;
}
.align-items-center {
	align-items: center;
}
.flex-item {
	flex: 1;
}
.display-none {
	display: none;
}
.text-align-center {
	text-align: center;
}
.text-align-right {
	text-align: right;
}
.vetical-align-top {
	vertical-align: top;
}
.vertical-align-middle {
	vertical-align: middle;
}
.vertical-align-bottom {
	vertical-align: bottom;
}
.float-right {
	float: right;
}
.drag-handle {
	cursor: move !important;
}
.clearfix {
	clear: both;
}

.tooltip {
	z-index: 30000 !important;
}
.mu-overlay {
	z-index: 10000 !important;
}
.mu-dialog-wrapper {
	z-index: 20000 !important;
}
.mu-drawer {
	z-index: 10002 !important;
}

.item-title {
	font-size: 18px;
	padding: 4px;
}
.mu-button {
	text-align: center;
}
.inline-icon {
	vertical-align: bottom;
}
.wordwrap {
	white-space: pre-wrap;
	word-wrap: break-all;
}

@media screen and (min-width: 945px) {
	.mobile-show {
		display: none !important;
	}
}
@media screen and (max-width: 944px) {
	.mobile-hide {
		display: none !important;
	}
	.item-title {
		font-size: 12px;
	}
}
::-webkit-scrollbar {
	width: 2px;
}

/* Track */
::-webkit-scrollbar-track {
	background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
	background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: #555;
}
</style>

<style lang="scss" scoped>
.app-content {
	padding-top: 64px;
	overflow: auto;
}
.footer {
	margin-left: 5px;
	margin-right: 5px;
}
@media screen and (max-width: 944px) {
	.footer {
		display: none;
	}
}
.result-list {
	position: absolute;
	z-index: 10;
	width: 256px;
	max-height: 50vh;
	overflow-y: auto;
}
.app-bar {
	position: fixed;
	height: 54px;
	z-index: 10001;
}
.search-bar-text-field {
	margin-bottom: 0px;
	padding-bottom: 0px;
}
.search-dialog-content {
	padding: 24px;
}
.checkbox-channel {
	padding-right: 10px;
}
.router-view-container {
	overflow-y: auto;
}
.button-home {
	cursor: pointer;
}
.app-bar-logo-wrapper {
	padding: 2px;
	border-radius: 10px;
	margin-right: 10px;
}
.app-bar-logo {
	line-height: 40px;
	text-align: center;
	vertical-align: middle;
	height: 40px;
}
.app-bar-logo-animation {
	animation-name: app-bar-logo;
	animation-duration: 1s;
	animation-iteration-count: infinite;
}
@keyframes app-bar-logo {
	0% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.1);
	}
	100% {
		transform: scale(1);
	}
}
</style>
<template>
	<div class="page-container display-flex display-flex-column" id="app">
		<div class="page-container display-flex display-flex-column" v-if="$route.name !== 'EmbedMedia'">
			<mu-appbar class="app-bar full-width" :color="isPreview ? 'primary' : 'secondary'" v-if="$route.name !== 'EmbedMedia'">
				<div slot="right">
					<mu-text-field v-model="modelSearchBar" v-if="authorized" class="search-bar-text-field mobile-hide" @focus="onFocus" @blur="onBlur">
						<mu-button icon @click="flagDialogFilter = true" slot="append" v-if="authorized && false" v-tooltip="$t('search.title')">
							<mu-icon value="filter_list" color="white"></mu-icon>
						</mu-button>
						<mu-icon value="search" slot="prepend" color="white"></mu-icon>
					</mu-text-field>
					<mu-button icon @click="flagDialogSearch = true" slot="append" v-if="authorized" v-tooltip="$t('search.title')" class="mobile-show">
						<mu-icon value="search" color="white"></mu-icon>
					</mu-button>
					<mu-paper :z-depth="1" class="result-list mobile-hide" v-if="isFocused && listSearchBar.length">
						<mu-list textline="three-line">
							<mu-list-item avatar button :ripple="false" v-for="(item, index) in listSearchBar" :key="index" @click="onClickSearchItem(item)">
								<mu-list-item-content>
									<mu-list-item-title>{{ item.name }}</mu-list-item-title>
									<mu-list-item-sub-title v-if="item.hasOwnProperty('parent')"
										>{{ item.parent }}
										<span v-if="item.type === 'media'">
											<br /><span v-for="(tag, index) in item.tags" :key="index"> #{{ tag }}</span>
										</span>
									</mu-list-item-sub-title>
								</mu-list-item-content>
							</mu-list-item>
						</mu-list>
					</mu-paper>
				</div>
				<NotificationPanel slot="right" v-if="authorized" />
				<BookmarkList slot="right" v-if="authorized" />
				<HistoryPanel slot="right" v-if="authorized" />
				<mu-button icon slot="right" class="mobile-hide" @click="onClickPreview" v-if="$store.getters.isAssistant" v-tooltip="tooltipPreview">
					<mu-icon value="find_in_page" v-if="!isPreview"></mu-icon>
					<mu-icon value="build" v-else></mu-icon>
				</mu-button>
				<mu-chip :color="isPreview ? 'primary' : 'secondary'" slot="right" @click="flagMenuApp = !flagMenuApp" v-if="authorized" v-tooltip="$t('button.menu')">
					<mu-avatar>
						<img :src="profile" v-if="$store.state.auth.user.profile !== '' && $store.state.auth.user.profile !== undefined" />
						<img :src="defaultAvatar" v-else />
					</mu-avatar>
					<span class="mobile-hide">{{ username }}</span>
				</mu-chip>
				<span @click="onActionHome" class="button-home" slot="left">
					<div class="app-bar-logo-wrapper">
						<img :src="logoNoText" height="40px" class="app-bar-logo" :class="fetching ? 'app-bar-logo-animation' : ''" />
					</div>
				</span>
			</mu-appbar>
			<mu-drawer :open.sync="flagMenuApp" :docked="false" right>
				<mu-list toggle-nested>
					<mu-list-item avatar>
						<mu-list-item-action>
							<mu-button icon slot="left" @click="flagMenuApp = !flagMenuApp">
								<mu-icon value="keyboard_arrow_right"></mu-icon>
							</mu-button>
						</mu-list-item-action>
						<mu-list-item-title>{{ username }}</mu-list-item-title>
						<mu-list-item-action>
							<mu-avatar>
								<img :src="profile" v-if="$store.state.auth.user.profile !== '' && $store.state.auth.user.profile !== undefined" />
								<img :src="defaultAvatar" v-else />
							</mu-avatar>
						</mu-list-item-action>
					</mu-list-item>
					<mu-list-item button @click="onActionHome">
						<mu-list-item-action>
							<mu-icon value="home"></mu-icon>
						</mu-list-item-action>
						<mu-list-item-title>{{ $t("button.home") }}</mu-list-item-title>
					</mu-list-item>
					<mu-divider></mu-divider>
					<mu-list-item button @click="onActionProfile">
						<mu-list-item-action>
							<mu-icon value="face"></mu-icon>
						</mu-list-item-action>
						<mu-list-item-title>{{ $t("profile.title") }}</mu-list-item-title>
					</mu-list-item>
					<mu-list-item button @click="onActionSettings">
						<mu-list-item-action>
							<mu-icon value="settings"></mu-icon>
						</mu-list-item-action>
						<mu-list-item-title>{{ $t("settings.title") }}</mu-list-item-title>
					</mu-list-item>
					<mu-list-item button @click="onActionTheme">
						<mu-list-item-action>
							<mu-icon value="color_lens"></mu-icon>
						</mu-list-item-action>
						<mu-list-item-title>{{ $t("theme.title") }}</mu-list-item-title>
					</mu-list-item>
					<mu-list-item button @click="onActionUsers" v-if="$store.getters.isAdmin">
						<mu-list-item-action>
							<mu-icon value="people"></mu-icon>
						</mu-list-item-action>
						<mu-list-item-title>{{ $t("users.title") }}</mu-list-item-title>
					</mu-list-item>
					<mu-list-item button @click="onActionApi" v-if="$store.getters.isAdmin">
						<mu-list-item-action>
							<mu-icon value="code"></mu-icon>
						</mu-list-item-action>
						<mu-list-item-title>{{ $t("api.title") }}</mu-list-item-title>
					</mu-list-item>
					<mu-list-item button @click="onActionLog" v-if="$store.getters.isAdmin">
						<mu-list-item-action>
							<mu-icon value="insert_drive_file"></mu-icon>
						</mu-list-item-action>
						<mu-list-item-title>{{ $t("log.title") }}</mu-list-item-title>
					</mu-list-item>
					<mu-divider></mu-divider>
					<mu-list-item button @click="onActionAbout">
						<mu-list-item-action>
							<mu-icon value="info"></mu-icon>
						</mu-list-item-action>
						<mu-list-item-title>{{ $t("about.title") }}</mu-list-item-title>
					</mu-list-item>
					<mu-list-item button @click="onClickLogout">
						<mu-list-item-action>
							<mu-icon value="exit_to_app"></mu-icon>
						</mu-list-item-action>
						<mu-list-item-title>{{ $t("logout.title") }}</mu-list-item-title>
					</mu-list-item>
				</mu-list>
			</mu-drawer>
			<transition name="fade">
				<div class="app-content display-flex display-flex-column flex-item" v-if="!isLoading">
					<div class="flex-item">
						<redirect-page v-if="$route.query.hasOwnProperty('ticket') || $route.query.hasOwnProperty('token')" />
						<router-view v-else-if="$store.state.auth.authorized" @logout="onActionLogout"></router-view>
						<login-page v-else />
					</div>
					<mu-row class="footer" v-if="isFrontPage">
						<mu-col><small>Ver 2.6.2</small></mu-col>
						<mu-col class="text-align-center"
							><small>{{ $t("app.copyright") }}</small></mu-col
						>
						<mu-col class="text-align-right"
							><small
								>{{ $t("app.initiate") }}<a href="//hub.hku.hk/rp/rp00033" target="_blank">{{ $t("app.initiate_person") }}</a
								>{{ $t("app.dot") }}</small
							></mu-col
						>
					</mu-row>
				</div>
			</transition>
			<mu-dialog :title="$t('logout.title')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogLogout">
				{{ $t("logout.msg") }}
				<mu-button slot="actions" flat color="primary" @click="flagDialogLogout = false">{{ $t("prompt.cancel") }}</mu-button>
				<mu-button slot="actions" flat color="primary" @click="onActionLogout">{{ $t("prompt.confirm") }}</mu-button>
			</mu-dialog>
			<mu-dialog transition="slide-bottom" fullscreen max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogSearch">
				<mu-appbar color="primary" :title="$t('prompt.search')">
					<mu-button slot="right" flat @click="flagDialogSearch = false">
						<mu-icon value="close"></mu-icon>
					</mu-button>
				</mu-appbar>
				<div class="search-dialog-content">
					<mu-text-field v-model="modelSearchBar" v-if="authorized" class="search-bar-text-field" @focus="onFocus" @blur="onBlur">
						<mu-icon value="search" slot="prepend"></mu-icon>
					</mu-text-field>
					<mu-list textline="three-line" style="overflow-y: auto">
						<mu-list-item avatar button :ripple="false" v-for="(item, index) in listSearchBar" :key="index" @click="onClickSearchItem(item)">
							<mu-list-item-content>
								<mu-list-item-title>{{ item.name }}</mu-list-item-title>
								<mu-list-item-sub-title v-if="item.hasOwnProperty('parent')"
									>{{ item.parent }}
									<span v-if="item.type === 'media'">
										<br /><span v-for="(tag, index) in item.tags" :key="index"> #{{ tag }}</span>
									</span>
								</mu-list-item-sub-title>
							</mu-list-item-content>
						</mu-list-item>
					</mu-list>
				</div>
			</mu-dialog>
		</div>
		<div v-else class="full-width full-height">
			<redirect-page v-if="$route.query.hasOwnProperty('ticket') || $route.query.hasOwnProperty('token')" />
			<router-view v-else-if="$store.state.auth.authorized" @logout="onActionLogout"></router-view>
			<embed-login v-else />
		</div>
	</div>
</template>

<script>
// Components
import LoginPage from "@/views/LoginPage.vue";
import RedirectPage from "@/views/RedirectPage.vue";

import EmbedLogin from "@/embed/Login.vue";
import NotificationPanel from "@/components/Notification/NotificationPanel.vue";
import BookmarkList from "@/components/Bookmark/List/Main.vue";
import HistoryPanel from "@/components/History/HistoryPanel.vue";

import ModelItem from "@/components/Media/Content/ModelItem.vue";

// Library
import axios from "axios";

// Assets
import defaultAvatar from "@/assets/img/default_avatar.png";

export default {
	name: "app",
	components: {
		LoginPage,
		RedirectPage,
		ModelItem,
		EmbedLogin,
		NotificationPanel,
		HistoryPanel,
		BookmarkList,
	},
	data: function () {
		return {
			// Flag
			flagDialogLogout: false, // Boolean variable for status of logout snackbar
			flagMenuApp: false, // Boolean variable for status of app menu
			flagDialogFilter: false,
			flagDialogSearch: false,
			isFocused: false,
			isLoading: true,

			modelSearchBar: null,
			listSearchBar: [],

			timeout: null,
			timeoutBlur: null,
			interval: null,
		};
	},
	computed: {
		// Asset
		defaultAvatar: function () {
			return defaultAvatar;
		},

		// Store
		username: function () {
			// Return full name of user, if no full name defined, then username
			if (typeof this.$store.state.auth.user.name === "undefined") return this.$store.state.auth.user.username;
			else return this.$store.state.auth.user.name;
		},
		profile: function () {
			// Return path of profile picture
			return this.$store.getters.urlStorage + "profile/" + this.$store.state.auth.user.profile;
		},
		authorized: function () {
			return this.$store.state.auth.authorized;
		},
		fetching: function () {
			return this.$store.state.loading.fetching;
		},

		// Flag
		isFrontPage: function () {
			return this.$route.name === "Home" || !this.$store.state.auth.authorized;
		},
		isPreview: function () {
			if (this.$store.getters.previewMode) {
				return true;
			} else {
				return false;
			}
		},

		tooltipPreview: function () {
			if (this.isPreview) {
				return this.$t("button.editOn");
			} else {
				return this.$t("button.editOff");
			}
		},

		routeQueryTicket() {
			if (this.$route.query.hasOwnProperty("ticket")) {
				return this.$route.query.ticket;
			} else {
				return "";
			}
		},
		routeQueryToken() {
			if (this.$route.query.hasOwnProperty("token")) {
				return this.$route.query.token;
			} else {
				return "";
			}
		},
		cookieToken() {
			return this.getCookie("token");
		},
	},
	watch: {
		authorized(newValue) {
			// Watch on authorized
			if (newValue) {
				this.fetchSettings();
			} else this.flagMenuApp = false;
		},
		modelSearchBar(newValue) {
			this.fetchSearch(newValue);
		},
		routeQueryTicket(newValue) {
			if (newValue) {
				window.location.href = this.$store.getters.urlApi + "auth/cas?ticket=" + newValue + "&redirect=" + this.$route.path;
				this.isLoading = false;
			}
		},
		routeQueryToken(newValue) {
			if (newValue) {
				document.cookie = "token" + "=" + (this.routeQueryToken || "") + "" + "; path=" + this.$route.query.redirect;
				this.loginByCas(newValue);
			}
		},
		cookieToken(newValue) {
			if (newValue) {
				document.cookie = "token" + "=" + (newValue || "") + "" + "; path=" + this.$route.query.redirect;
				this.login(newValue);
			}
		},
	},
	beforeCreate() {},
	created: function () {
		this.flagMenuApp = false;
	},
	mounted() {
		this.initAuth();
		this.interval = setInterval(() => {
			this.$store.commit("updateRoute", this.$router);
		}, 60000);
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
	methods: {
		initAuth() {
			var split = this.$route.path.split("/");
			console.log(window.location.pathname);
			if (split[1] === "c") {
				window.location.href = this.$store.getters.urlApi + "auth/cas?redirect=/" + split.splice(2).join("/");
				this.isLoading = false;
			} else if (this.$route.query.hasOwnProperty("ticket")) {
				window.location.href = this.$store.getters.urlApi + "auth/cas?ticket=" + this.$route.query.ticket + "&redirect=" + window.location.pathname;
				this.isLoading = false;
			} else if (this.$route.query.hasOwnProperty("token")) {
				document.cookie = "token" + "=" + (this.routeQueryToken || "") + "" + "; path=" + this.$route.query.redirect;
				this.loginByCas(this.routeQueryToken);
			} else if (this.getCookie("token") !== null) {
				this.login(this.getCookie("token"));
			} else {
				this.$store.commit("logout");
				this.isLoading = false;
			}
		},
		loginByCas(token) {
			axios
				.get(this.$store.getters.urlApi + "auth", {
					headers: {
						token: token,
					},
				})
				.then((response) => {
					var user = response.data.data.user;
					this.isLoading = false;
					this.$store.commit("loginByCas", { token: token, path: window.location.pathname, user: user });
				})
				.catch(() => {
					this.isLoading = false;
				});
		},
		login(token) {
			axios
				.get(this.$store.getters.urlApi + "auth", {
					headers: {
						token: token,
					},
				})
				.then((response) => {
					var user = response.data.data.user;
					this.isLoading = false;
					this.$store.commit("login", { token: token, path: window.location.pathname, user: user });
				})
				.catch(() => {
					this.isLoading = false;
				});
		},
		// Fetch
		fetchSettings: function () {
			this.$store.dispatch("fetchSettings");
		},
		fetchSearch: function (searchTerm) {
			if (searchTerm === "" || typeof searchTerm !== "string") {
				this.listSearchBar = [];
			} else {
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					axios
						.get(this.$store.getters.urlApi + "search?query=" + searchTerm, {
							headers: {
								token: this.$store.state.auth.token,
							},
						})
						.then((response) => {
							this.listSearchBar = response.data.data.results;
						});
				}, 500);
			}
		},

		// Event
		onClickLogout: function () {
			this.flagDialogLogout = true;
		},
		onActionLogout: function () {
			this.flagDialogLogout = false;
			axios
				.delete(this.$store.getters.urlApi + "auth", {
					headers: {
						token: this.$store.state.auth.token,
					},
					params: {
						ids: this.attachmentIds,
					},
				})
				.then(() => {
					var type = this.$store.state.auth.user.type;
					this.$store.commit("logout");
					this.flagMenuApp = false;
					if (type === "cas") {
						window.location.href = this.$store.getters.urlCasLogout;
					}
				});
		},
		onActionHome: function () {
			this.flagMenuApp = false;
			this.$router.push({
				name: "Home",
			});
		},
		onActionChannel: function (channel) {
			this.flagMenuApp = false;
			this.$router.push({
				name: "Channel",
				params: {
					channelId: channel._id,
				},
			});
		},
		onActionAnalytics: function (channel) {
			this.flagMenuApp = false;
			this.$router.push({
				name: "Analytics",
				params: {
					channelId: channel._id,
				},
			});
		},
		onActionProfile: function () {
			this.flagMenuApp = false;
			this.$router.push({
				name: "Profile",
			});
		},
		onActionSettings: function () {
			this.flagMenuApp = false;
			this.$router.push({
				name: "Settings",
			});
		},
		onActionTheme: function () {
			this.flagMenuApp = false;
			this.$router.push({
				name: "Theme",
			});
		},
		onActionUsers: function () {
			this.flagMenuApp = false;
			this.$router.push({
				name: "Users",
			});
		},
		onActionLog: function () {
			this.flagMenuApp = false;
			this.$router.push({
				name: "Log",
			});
		},
		onActionApi: function () {
			this.flagMenuApp = false;
			this.$router.push({
				name: "Api",
			});
		},
		onActionAbout: function () {
			this.flagMenuApp = false;
			this.$router.push({
				name: "About",
			});
		},
		onClickSearchItem: function (item) {
			this.flagMenuApp = false;
			this.flagDialogSearch = false;
			this.$router.push({
				path: "/" + item.type + "/" + item.id,
			});
		},
		onClickPreview: function () {
			this.$store.commit("previewMode");
		},

		onFocus() {
			this.isFocused = true;
		},
		onBlur() {
			this.timeoutBlur = setTimeout(() => {
				this.isFocused = false;
			}, 500);
		},

		getCookie: function (name) {
			var nameEQ = name + "=";
			var ca = document.cookie.split(";");
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == " ") c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		},
	},
};
</script>
